var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "button",
      {
        staticClass: "btn btn-sm btn-cog",
        attrs: { type: "button", id: "popover-config-" + _vm.content.id }
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("settings")]),
        _vm._v(" "),
        _c(
          "b-popover",
          {
            ref: "popover",
            attrs: {
              target: "popover-config-" + _vm.content.id,
              triggers: "click blur",
              placement: "bottom"
            }
          },
          [
            _c(
              "div",
              _vm._l(_vm.config.fields, function(configField) {
                return _c(
                  "b-form-group",
                  { key: configField },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          value: "1",
                          "unchecked-value": "0",
                          checked: _vm.content[configField]
                        },
                        on: {
                          input: function(value) {
                            return _vm.updateField(configField, value)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formatLabel(configField)) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fb04196", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb04196","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/PopoverConfigComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2fb04196","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/PopoverConfigComponent.vue
// module chunks = 0